import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";
import estilo from "./footer.module.css";

const Footer = () => {
    const icons = [
        { component: FaFacebook, link: "https://www.facebook.com/profile.php?id=61582920286190" },
        { component: FaInstagram, link: "https://instagram.com/luis_carlos_trentin" },
        { component: FaWhatsapp, link: "https://wa.me/5528999575091" },
    ];

    return (
        <motion.footer
            className={estilo.footer}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
        >
            <div className={estilo.socialIcons}>
                {icons.map((item, index) => {
                    const Icon = item.component;
                    return (
                        <motion.a
                            key={index}
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.1, color: "#519beb" }}
                            transition={{ duration: 0.3 }}
                            className={estilo.iconWrapper}
                        >
                            <Icon className={estilo.icon} />
                        </motion.a>
                    );
                })}
            </div>

            <p>&copy; {new Date().getFullYear()} Luis Carlos. Todos os direitos reservados.</p>
        </motion.footer>
    );
};

export default Footer;
